<script>
    import debounce from 'lodash/debounce'
    import clone from 'lodash/clone'
    import Condition from './Condition.vue'
    import KSModalFilters from './KSModalFilters.vue'
    import '@imengyu/vue3-context-menu/lib/vue3-context-menu.css'
    import {ContextMenu, ContextMenuItem} from '@imengyu/vue3-context-menu';
    import {get} from 'lodash';
    import {Listeners} from "../../constants/listeners";
    import Button from "primevue/button";
    import InputText from "primevue/inputtext";
    import Textarea from "primevue/textarea";
    import AdaptersDropdown from "../adapters/Dropdown.vue";
    import AdaptersDialog from "../adapters/Dialog.vue";
    import AdaptersDataTable from "../adapters/DataTable.vue";
    import Column from "primevue/column";
    import AdaptersOverlayPanel from "../adapters/OverlayPanel.vue";
    import {FilterConstants} from "keysso/constants/filterConstants";
    import {FilterHelper} from "../../helpers/FilterHelper";

    const OPERATORS = [
        '>=',
        '<=',
        'NOT LIKE',
        'LIKE',
        '!=',
        '=',
        '>',
        '<',
        'BETWEEN',
        'STARTSWITH',
        'ENDSWITH',
        'IN ARRAY',
        'NOT IN ARRAY' ,'NOT IN',
        'IN',
        'NOT REGEXP',
        'REGEXP',
        'MATCH',
        'hasAllLike',
        'hasNoOneLike',
        'notExistsLike',
        'existsLike',
        'MASK',
        'NOT ONE OF',
        'ONE OF',
        'NOT ARRAY CONTAINS',
        'ARRAY CONTAINS',
        'NOT ARRAY HAS ANY',
        'ARRAY HAS ANY',
    ];
    // типы полей с мультивыбором — значение массив; из ссылки разбиваем по типу поля, а не по оператору:
    // у «Один из» для строк и чисел (ввод списком) значение остаётся строкой
    const MULTI_SELECT_TYPES = ['wizards', 'regions', 'arr', 'zenPublicationsTypes', 'rel_type'];

    export default {
        name: "KSFilter",
        data() {
            return {
                filter: '',
                filters: [],
                forDay: 3,
                filterConfig: null,
                showContextMenu: false,
                contextMenuOptions: {
                    iconFontClass: 'iconfont',
                    customClass: "class-a",
                    zIndex: 3,
                    minWidth: 230,
                    x: 500,
                    y: 200
                },
                csvExportProgress: {
                    active: false,
                    indeterminate: false,
                    currentPart: 0,
                    totalParts: 1,
                    progressPercent: 0,
                },
            }
        },
        props: {
            label: {
                type: String,
                required: false
            },
            description: {
                type: String,
                required: false,
            },
            fields: {
                type: Array,
                required: true
            },
            additionalActions: {
                type: Array,
                required: false
            },
            reportName: {
                type: String,
                required: false
            },
            /**
             * Условие, без которого API отчёта отвечает 400 (например 'status=1').
             * Сброс фильтров возвращает к нему, а не в пустоту.
             * Всегда стоит первой строкой: без крестика и «ИЛИ», поле в ней не переключается.
             */
            requiredFilter: {
                type: String,
                required: false,
                default: ''
            },
            isAuthorized: {
                type: Boolean,
                required: false
            },
            isDownload: {
                type: Boolean,
                required: false,
                default: true
            },
            isDownloadImages: {
                type: Boolean,
                required: false,
                default: false
            },
            isEncoding: {
                type: Boolean,
                required: false,
                default: false
            },
            isCopy: {
                type: Boolean,
                required: false,
                default: false
            },
            isInfo: {
                type: Boolean,
                required: false,
                default: true
            },
            allowOrCondition: {
                type: Boolean,
                required: false,
                default: true
            },
            showDayChange: {
                type: Boolean,
                required: false,
                default: false
            },
            isTextarea : {
                type: Boolean,
                required: false,
                default: false
            },
            showExample : {
                type: Boolean,
                required: false,
                default: false
            },
            maxListCount: {
                type: Number,
                required: false,
                default: 0
            },
            isRsya: {
                type: Boolean,
                required: false,
                default: false,
            },
            isHideDefaultSearch: {
                type: Boolean,
                required: false,
                default: false,
            },
            debounceDisabled: {
                type: Boolean,
                required: false,
                default: false,
            },
            // режим отчёта для visibleRule полей: строка (backlinks: "all") или число (органика/контекст: 0/1)
            viewMode: {
                type: [String, Number],
                required: false,
                default: "",
            },
            top: {
                type: Number,
                required: false,
                default: 50
            }
        },
        computed: {
            list(){
                if(this.filter){
                    return this.filter.replace(/\r\n/g,"\n").split("\n").map(item => item.trim()).filter(item => {return item != ""});
                }
                return [];
            },
            listCount(){
                return this.list.length;
            },
            listOverflowed() {
                return this.listCount > this.maxListCount && this.isTextarea
            },
            filterFields(){
                return this.fields.map((e) => {
                    let field = clone(e);

                    if(field.hasOwnProperty('sortField')){
                        field.name = field.sortField;
                    }else{
                        let fieldSplit = field.name.split(':');
                        if(fieldSplit.length > 1){
                            field.name = fieldSplit[1];
                        }
                    }

                    // Если есть кастомная конфигурация операторов - используем её, иначе берём из глобального конфига
                    field.operatorOptions = field.operatorsConfig || (this.filterConfig?.[field.type] || []);


                    return field;
                }).filter(e => {
                    // self нужно для visibleRule
                    let self = this
                    if(e.hasOwnProperty('visibleRule')){
                        let visible = eval(e.visibleRule);
                        return visible && e.useInFilter
                    }
                    return e.useInFilter
                });
            },
            defaultSearchFields(){
                return this.fields.map((e) => {
                    let field = clone(e);

                    if(field.hasOwnProperty('sortField')){
                        field.name = field.sortField;
                    }else{
                        let fieldSplit = field.name.split(':');
                        if(fieldSplit.length > 1){
                            field.name = fieldSplit[1];
                        }
                    }

                    return field;
                }).filter((e) => e.defaultSearch);
            },
            columnInfo(){
                return this.fields.filter((e) => (e.hasOwnProperty('title'))).map((e) => {
                    return {
                        ...e,
                        field: e.title,
                    };
                });

            },
            getFilterApiUrl(){
                return this.$config.API_URL + '/report/filter';
            },
            isDownloadEncoding(){
                return this.isEncoding && window.locale === 'ru';
            },
            getShowInfoListenerId() {
                return Listeners.KS_POPUP_SHOW_INFO_KSTABLE_COLUMNS;
            },
            isFilterFilled(){
                return this.filter !== '' || this.filters.length > 0;
            }
        },
        methods: {
            isCsvExportLocked() {
                return this.csvExportProgress.active;
            },
            onCsvExportProgress(data = {}) {
                // Прогресс-бар убрали: выгрузка идёт одним запросом, показываем
                // неопределённый лоадер, как при обычной выгрузке.
                this.csvExportProgress.indeterminate = true;
                this.csvExportProgress.active = ['queued', 'processing'].includes(data?.status);
            },
            onCsvExportFinished() {
                this.csvExportProgress.active = false;
                this.csvExportProgress.indeterminate = false;
            },
            getCsvProgressCircleStyle() {
                const percent = Math.max(0, Math.min(100, Number(this.csvExportProgress.progressPercent || 0)));
                return {
                    background: `conic-gradient(#6EB116 ${percent}%, #818891 ${percent}% 100%)`,
                };
            },
            setDayHandler(e) {
                this.forDay = parseInt(e.target.dataset.day);
                this.$emitter.emit(Listeners.KS_FILTER_SET_FOR_DAY, this.forDay);
            },
            getEmptyFilterPayload(){
                let index = this.filterFields.findIndex(f => {
                   return f.hasOwnProperty('engine') && f.hasOwnProperty('isDefault') && f.isDefault && f.engine === window.report_db.engine;

                }), cIndex;



                if(index === -1){
                    index = this.filterFields.findIndex(f => {
                        return f.hasOwnProperty('isDefault') && f.isDefault;

                    })
                }

                if(index === -1){
                    index = 0;
                }

                const field = this.filterFields[index];
                const operatorOptions = field.operatorOptions || (this.filterConfig?.[field.type] || []);
                const operator = operatorOptions.length ? operatorOptions[0].condition : null;

                return {
                    type: field.type,
                    name: field.name,
                    operator: operator,
                    value: null,
                    operatorOptions: operatorOptions
                }
            },
            doFilter() {
                if (this.listOverflowed) {
                    return;
                }
                this.$emitter.emit(Listeners.LOAD_GROUP_REPORT_DATA_FROM_HASH);
                this.$emitter.emit(Listeners.KS_FILTER_SET, this.getQuery());
            },
            download(e, encoding) {
                if (this.isCsvExportLocked()) {
                    return;
                }
                this.csvExportProgress.active = true;
                this.csvExportProgress.indeterminate = true;
                let params = [];
                if(encoding){
                    params.push(`encoding=${encoding}`);
                }
                this.$emitter.emit(Listeners.KS_TABLE_DOWNLOAD, params);

                this.$refs["overlay-download"].hide();
            },
            copy() {
                this.$emitter.emit(Listeners.KS_TABLE_COPY);
            },
            downloadImages() {
                this.$emitter.emit(Listeners.KS_TABLE_DOWNLOAD_IMAGES);
            },
            applyEvent(func) {
                func.apply(this);
            },
            doFilterDebounce: debounce(
                function () {
                    if (!this.debounceDisabled) {
                        this.doFilter();
                    }
                },
                1500
            ),
            clearFilter() {
                this.filter = '';
                this.filters.splice(0, this.filters.length);

                if (this.requiredFilter) {
                    // Без этого условия отчёт вернёт 400, поэтому сбрасываем к нему, а не в пустоту
                    this.restoreFilter(this.requiredFilter);
                    this.doFilter();
                    return;
                }

                if(this.filters.length === 0){
                    this.initFilters();
                }
                this.$emitter.emit(Listeners.KS_DELETE_FILTER_PARAMS);
            },
            resetFilter() {
                this.clearFilter()
                // KS_FILTER_RESET снимает фильтр у таблицы; при обязательном условии
                // его уже переставил doFilter() выше, второй сброс только сломал бы запрос
                if (!this.requiredFilter) {
                    this.$emitter.emit(Listeners.KS_FILTER_RESET);
                }
                this.$emitter.emit(Listeners.RESET_FILTER_GROUP_REPORT);
            },
            initFilters(){
                this.filters.push(this.getEmptyFilterPayload());
            },
            // Обязательное условие первой строкой и хотя бы одна обычная строка под ним
            ensureDefaultRows() {
                if (this.requiredFilter) {
                    this.ensureRequiredRow();
                }

                if (this.filters.length === (this.requiredFilter ? 1 : 0)) {
                    this.initFilters();
                }
            },
            ensureRequiredRow() {
                const [name, value] = FilterHelper.decode(this.requiredFilter).split('=');
                const index = this.filters.findIndex(f => f.name === name);

                if (index === 0) {
                    return;
                }

                if (index > 0) {
                    this.filters.unshift(...this.filters.splice(index, 1));
                    return;
                }

                // условия нет, например в фильтре, сохранённом до того, как оно стало обязательным
                const field = this.filterFields.find(f => f.name === name);
                this.filters.unshift({
                    type: field.type,
                    name: name,
                    operator: '=',
                    value: value,
                    operatorOptions: field.operatorOptions
                });
            },
            isRequiredRow(index) {
                return !!this.requiredFilter && index === 0;
            },
            // Поле обязательного условия есть только в строке, где оно уже выбрано: в первой
            // и в пришедших из хэша или сохранённого фильтра — иначе их селект окажется пустым
            rowFilterFields(filter) {
                const name = this.requiredFilter ? FilterHelper.fieldName(this.requiredFilter) : '';

                if (!name || filter.name === name) {
                    return this.filterFields;
                }

                return this.filterFields.filter(f => f.name !== name);
            },
            updateModel(filter){
                const filterData = this.filterFields.filter((e) => e.name === filter.name)[0];
                const type = filterData.type;
                
                // Используем операторы из поля (если есть кастомные) или из глобального конфига
                const operatorOptions = filterData.operatorOptions || (this.filterConfig?.[type] || []);
                let operator = operatorOptions.length ? operatorOptions[0].condition : null;
                
                if (!operator) {
                    // Fallback на старую логику
                    let position = type === 'number' ? 4 : (type === 'string' ? 2 : 0);
                    operator = this.filterConfig[type]?.[position]?.condition || null;
                }

                // при переходе между полями-датами («Дата обновления» → «Дата создания») выбранный период сохраняется
                const keepPeriod = FilterConstants.DATE_RANGE_TYPES.includes(type) && filter.type === type && filter.value;

                filter.type = type;
                filter.operator = operator;
                filter.operatorOptions = operatorOptions;

                if (keepPeriod) {
                    return;
                }

                let value = null;
                if (get(filterData, 'defaultValue') ) {
                    value = filterData.defaultValue();
                } else if (MULTI_SELECT_TYPES.includes(type)) {
                    value = [];
                }

                if (type === "arr") {
                    filter.items = filterData.items;
                    value = [];
                }

                filter.value = value;
            },
            applySavedFilter(item){
                let self = this;

                // нет поиска в сохранённом фильтре (в т.ч. у старых, где поля нет) — очищаем строку поиска
                this.filter = item.filter || '';

                this.filters.splice(0, this.filters.length);
                item.filters.forEach(item => {
                    self.filters.push(item);
                });
                this.ensureDefaultRows();
                this.doFilter();
            },
            contextFilterSet(data) {
                const field = this.filterFields.find(f => f.name === data.name);
                const operatorOptions = field?.operatorOptions || (this.filterConfig?.[data.type] || []);
                
                if (this.filters.length === 1 && (this.filters[0].value === null || this.filters[0].value == "")) {
                    this.filters[0].type = data.type;
                    this.filters[0].name = data.name;
                    this.filters[0].operator = data.condition;
                    this.filters[0].value = data.value;
                    this.filters[0].operatorOptions = operatorOptions;
                } else {
                    this.filters.push({
                        type: data.type,
                        name: data.name,
                        operator: data.condition,
                        value: data.value,
                        operatorOptions: operatorOptions
                    });
                }

                this.doFilter();
            },
            restoreFilter(filter){
                this.filters.splice(0, this.filters.length);

                let filterItems = decodeURIComponent(filter).split("^"),
                    self = this;

                let getObject = function(str, fieldsKey = 'filterFields'){

                    let result = null,
                        operators = OPERATORS;


                    for (let i = 0; i < operators.length; i++) {
                        let pieces = str.split(operators[i]);
                        if(pieces.length === 2 && pieces[0] !== ""){
                            let tmp = self[fieldsKey].filter((f) => {return f.name === pieces[0]});
                            if(tmp.length === 1){
                                tmp = tmp[0];
                                let value = pieces[1];
                                if (MULTI_SELECT_TYPES.includes(tmp.type)) {
                                    value = value.split(FilterConstants.FILTER_ARRAY_DELIMITER);
                                }

                                result = {
                                    type: tmp.type,
                                    name: tmp.name,
                                    operator: operators[i],
                                    value: value,
                                    operatorOptions: tmp.operatorOptions || (self.filterConfig?.[tmp.type] || []),
                                    // варианты списка для типа arr, как при выборе поля в updateModel
                                    items: tmp.items,
                                };

                                break;
                            }
                        }
                    }

                    return result;
                };

                // строка фильтра, к которой относятся следующие «ИЛИ»; после поиска или неизвестного поля — нет
                let parent = null;
                for (const part of filterItems) {
                    if (part.substr(0, 2) === "OR") {
                        if (parent) {
                            if (!parent.hasOwnProperty('or')) {
                                parent['or'] = [];
                            }
                            parent['or'].push(getObject(part.substr(2)));
                        }
                        continue;
                    }

                    const item = getObject(part);
                    if (item) {
                        self.filters.push(item);
                        // строка из реактивного массива, чтобы добавление «ИЛИ» обновляло панель
                        parent = self.filters[self.filters.length - 1];
                        continue;
                    }

                    parent = null;
                    const searchItem = getObject(part, 'defaultSearchFields');
                    if (searchItem) {
                        self.filter = searchItem.value;
                    }
                }

                this.ensureDefaultRows();

            },
            addFilterRow(){
                this.initFilters();
            },
            addOrFilterRow(filter) {
                if (!filter.hasOwnProperty('or')){
                    filter['or'] = [];
                }

                let child = clone(filter);
                delete child.or;
                child.value = null;

                filter.or.push(child);
            },
            removeFilterRow(index){
                this.filters.splice(index, 1);
                this.ensureDefaultRows();
            },
            getQuery(){
                let query = [];
                if(this.filter){
                    let subQuery = this.defaultSearchFields;
                    if(subQuery.length === 1){
                        query = subQuery.map((s) =>  s.name + 'LIKE' + this.filter)
                    }else if(subQuery.length > 1){
                        query.push(subQuery.map((s) =>  s.name + 'LIKE' + this.filter).join('^OR'));
                    }
                }

                this.filters.forEach((filter) => {

                    if(filter.operator && filter.value !== null && filter.value !== ""){
                        // разделитель \n для массива в фильтре, ',' - deprecated
                        const filterValue = (Array.isArray(filter.value)
                            ? filter.value.map(String).join(FilterConstants.FILTER_ARRAY_DELIMITER)
                            : String(filter.value));

                        if(filter.hasOwnProperty('or') && filter.or.length > 0){
                            let orQuery = [];
                            orQuery.push(filter.name + filter.operator + filterValue);

                            filter.or.forEach((f) => {
                                if (f.operator && f.value !== null && f.value !== '') {
                                    const orFilterValue = (Array.isArray(f.value)
                                        ? f.value.map(String).join(FilterConstants.FILTER_ARRAY_DELIMITER)
                                        : String(f.value));
                                    orQuery.push(f.name + f.operator + orFilterValue);
                                }
                            });
                            query.push(orQuery.join('^OR'));
                        }else{
                            query.push(filter.name + filter.operator + filterValue);
                        }

                    }

                });

                return encodeURIComponent(query.join('^'));
            },
            onContextMenu(e) {
                e.preventDefault();
                //Set the mouse position
                this.contextMenuOptions.x = e.x;
                this.contextMenuOptions.y = e.y;
                //Show menu
                this.showContextMenu = true;
            },
            onShowInfo() {
                this.$emitter.emit(this.getShowInfoListenerId);
            },
            onShowDownloadOverlay(e) {
                if (this.isCsvExportLocked()) {
                    return;
                }
                this.$refs["overlay-download"].show(e);
            }
        },
        created() {
            this.filterConfig = this.$tm('lang.main.filter_config');
        },
        mounted() {
            this.ensureDefaultRows();

            this.$emitter.on(Listeners.KS_FILTER_SUBMIT_FORM, this.doFilter);
            this.$emitter.on(Listeners.KS_FILTER_CONTEXT_SET, data => this.contextFilterSet(data));
            this.$emitter.on(Listeners.KS_FILTER_APPLY_SAVED, data => this.applySavedFilter(data));
            this.$emitter.on(Listeners.KS_FILTER_CLEAR, this.resetFilter);
            this.$emitter.on(Listeners.KS_FILTER_SIMPLE_CLEAR, this.clearFilter);
            this.$emitter.on(Listeners.KS_TABLE_CSV_EXPORT_PROGRESS, this.onCsvExportProgress);
            this.$emitter.on(Listeners.KS_TABLE_CSV_EXPORT_FINISHED, this.onCsvExportFinished);

            if(window.location.hash !== ""){
                let self = this;
                const hashs = window.location.hash.slice(window.location.hash.indexOf('#') + 1).split('&');

                hashs.forEach((h) => {
                    const hash = h.split("=");
                    if(hash.length === 2){

                        switch (hash[0]) {
                            case "filter":
                                self.restoreFilter(decodeURIComponent(hash[1]));
                                break;
                            case "forDay":
                                this.forDay = parseInt(hash[1]);
                                break;
                        }

                    }

                });
            }
        },
        beforeUnmount() {
            this.$emitter.off(Listeners.KS_TABLE_CSV_EXPORT_PROGRESS, this.onCsvExportProgress);
            this.$emitter.off(Listeners.KS_TABLE_CSV_EXPORT_FINISHED, this.onCsvExportFinished);
        },
        components: {
            AdaptersOverlayPanel,
            AdaptersDialog,
            Condition,
            ContextMenu,
            ContextMenuItem,
            'ks-modal-filters': KSModalFilters,
            Button,
            InputText,
            Textarea,
            AdaptersDropdown,
            AdaptersDataTable,
            Column,
        }

    }
</script>
<template>
    <div class="filter" :class="'report_name__' + reportName">
        <AdaptersDialog :listener-id="getShowInfoListenerId" :header="$t('lang.main.filter.show_info_title')">
            <template #content>
                <AdaptersDataTable :params="{value: columnInfo}" :useCustomPagination="false">
                    <Column field="field" :header="$t('lang.main.filter.field')">
                        <template #body="{ data }">
                            <div v-html="data.field" />
                        </template>
                    </Column>
                    <Column field="description" :header="$t('lang.group.start.column_name')">
                        <template #body="{ data }">
                            <a v-if="data.link" :href="data.link">
                                <span v-html="data.description"></span>
                            </a>
                            <span v-else v-html="data.description"></span>
                        </template>
                    </Column>
                </AdaptersDataTable>
            </template>
        </AdaptersDialog>

        <h2 v-if="label"><i class="icon filter"></i><span v-html="label"></span></h2>
        <p v-if="description" v-html="description" class="ks-filter-desc"></p>

        <div class="search_container w-full sm:w-auto">
            <div>
                <div class="f-row">
                    <div v-if="!isHideDefaultSearch" :class="!isTextarea ? `filter-search-field-container` : ``">
                        <input v-if="!isTextarea" type="search" class="varcharlike filter-search-field" placeholder="" @keyup="doFilterDebounce" v-model="filter">
                        <label v-if="isTextarea && maxListCount > 0" class="counter-info">
                            <span class="char-count">
                                <span :class="{'text-red-500': listOverflowed}">
                                    {{listCount.formatMoney(0, ' ', ' ')}} /
                                </span>
                                {{maxListCount.formatMoney(0, ' ', ' ')}}
                            </span>
                        </label>
                        <textarea v-if="isTextarea" placeholder="Введите текст запроса" cols="90" rows="2" type="search" v-model="filter"></textarea>
                    </div>
                    <slot name="additional"></slot>
                </div>

                <div class="f-row" v-for="(filter, index) in filters">
                    <div class="f-row-item">
                        <select class="fieldselect" v-model="filter.name" @change="updateModel(filter)" :disabled="isRequiredRow(index)">
                            <option v-for="field in rowFilterFields(filter)" :value="field.name" v-text="field.filterTitle"></option>
                        </select>

                        <condition :item="filter"></condition>

                        <a href="#" class="graybutton" @click.prevent="addFilterRow">{{$t('lang.main.filter.and')}}</a>
                        <a href="#" class="graybutton" @click.prevent="addOrFilterRow(filter)" v-if="allowOrCondition && !isRequiredRow(index)">{{$t('lang.main.filter.or')}}</a>
                        <a href="#" class="graybutton" @click.prevent="removeFilterRow(index)" v-if="!isRequiredRow(index)"><i class="fa fa-times" aria-hidden="true"></i></a>
                    </div>

                    <!-- OR -->
                    <div class="f-row child" v-for="(or, index) in filter.or" v-if="allowOrCondition">
                        <div class="f-row-item">
                            <select class="fieldselect" v-model="or.name" @change="updateModel(or)">
                                <option v-for="field in rowFilterFields(or)" :value="field.name" v-text="field.filterTitle"></option>
                            </select>

                            <condition :item="or"></condition>

                            <a href="#" class="graybutton" @click.prevent="filter.or.splice(index, 1)"><i class="fa fa-times" aria-hidden="true"></i></a>
                        </div>
                    </div>
                    <!-- OR EOF-->
                </div>
            </div>

            <div class="search_example" v-if="showExample">
                <slot name="example"></slot>
            </div>
        </div>
        <slot name="rsya_actions"></slot>
        <div class="f-row button-group">
            <a href="#" class="greenbutton" :class="{'graybutton': listOverflowed, 'disabled-link': listOverflowed}" @click.prevent="doFilter" :title="$t('lang.main.filter.apply')">{{$t('lang.main.btn.apply')}}</a>
            <a href="#" class="graybutton" @click.prevent="resetFilter" :title="$t('lang.main.filter.clear')">{{$t('lang.main.btn.clear')}}</a>
            <ks-modal-filters :filter="filter" :filters="filters" :reportName="reportName" v-if="isAuthorized"></ks-modal-filters>

            <a href="#" class="graybutton pull-right" @click.prevent="onShowInfo" v-if="isInfo"><i class="fa fa-info-circle" aria-hidden="true"></i></a>
            <a
                v-if="isDownload && !isDownloadEncoding"
                href="#"
                class="greenbutton pull-right"
                :class="{
                    'csv-export-button-active': csvExportProgress.active,
                    'disabled-link': isCsvExportLocked()
                }"
                @click.prevent="download"
                :title="$t('lang.main.download_file_csv')"
            >
                <span
                    v-if="csvExportProgress.active && !csvExportProgress.indeterminate"
                    class="csv-export-progress__circle-btn"
                    :style="getCsvProgressCircleStyle()"
                    aria-hidden="true"
                >
                    <span class="csv-export-progress__circle-btn-inner"></span>
                </span>
                <i
                    v-else-if="csvExportProgress.active"
                    class="fa fa-spinner fa-spin csv-export-spinner"
                    aria-hidden="true"
                ></i>
                <i v-else class="fa fa-download" aria-hidden="true"></i>
            </a>
            <a
                v-if="isDownload && isDownloadEncoding"
                href="#"
                class="greenbutton pull-right"
                :class="{
                    'csv-export-button-active': csvExportProgress.active,
                    'disabled-link': isCsvExportLocked()
                }"
                @click.prevent.stop="onShowDownloadOverlay($event)"
                ref="encoding"
                :title="$t('lang.main.download_file_csv')"
            >
                <span
                    v-if="csvExportProgress.active && !csvExportProgress.indeterminate"
                    class="csv-export-progress__circle-btn"
                    :style="getCsvProgressCircleStyle()"
                    aria-hidden="true"
                >
                    <span class="csv-export-progress__circle-btn-inner"></span>
                </span>
                <i
                    v-else-if="csvExportProgress.active"
                    class="fa fa-spinner fa-spin csv-export-spinner"
                    aria-hidden="true"
                ></i>
                <i v-else class="fa fa-download" aria-hidden="true"></i>
            </a>
            <a href="#" class="greenbutton pull-right" @click.prevent="copy" :title="$t('lang.main.copy_to_clipboard_field')" v-if="isCopy"><i class="fa fa-clipboard" aria-hidden="true"></i></a>
            <template v-for="action in additionalActions">
                <a href="#" class="greenbutton pull-right" @click.prevent="applyEvent(action.event)" v-if="action.icon.length === 0" :title="action.label">{{action.label}}</a>
                <a href="#" class="greenbutton pull-right" @click.prevent="applyEvent(action.event)" v-if="action.icon.length !== 0" :title="action.label"><i :class="action.icon.join(' ')" aria-hidden="true"></i></a>
            </template>
            <a href="#" class="greenbutton pull-right" @click.prevent="downloadImages" v-if="isDownloadImages" v-text="$t('lang.main.download_images')"></a>
            <div :class="['vuefilter-for-day pull-right']" @click.prevent="setDayHandler" v-if="showDayChange">
                <a class="graybutton" data-day="3" v-bind:class="{ 'filter-day-active': this.forDay === 3 }">{{ $t('lang.main.filter.for_3_day') }}</a>
                <a class="graybutton" data-day="7" v-bind:class="{ 'filter-day-active': this.forDay === 7 }">{{ $t('lang.main.filter.for_week') }}</a>
                <a class="graybutton" data-day="30" v-bind:class="{ 'filter-day-active': this.forDay === 30 }">{{ $t('lang.main.filter.for_month') }}</a>
            </div>
        </div>
        <AdaptersOverlayPanel ref="overlay-download">
            <ul class="overlay_download__content">
                <li @click="download" class="mb-2 cursor-pointer">{{ $t('lang.main.csv_utf') }}</li>
                <li @click="download($event, 'cp1251')" class="cursor-pointer">{{ $t('lang.main.csv_cp1251') }}</li>
            </ul>
        </AdaptersOverlayPanel>
    </div>

</template>

<style scoped>
    .overlay_download__content {
        list-style: none;
        font-size: 13px;
    }

    .csv-export-spinner {
        color: #6EB116;
    }
    a.graybutton, a.greenbutton  {text-decoration: none; padding: 0 10px; font-size: 13px;}
    .region-info{display: block; font-size: 14px;}

    .tbl-container{
        overflow-x: hidden;
        overflow-y: scroll;
        height: 400px;
        padding-top: 5px;
    }
    .tbl-container p{
        margin: inherit;
        font-size: 13px;
    }

    .ks-context-menu{
        margin-top: 0px!important;
        margin-left: -5px!important;
        text-transform: initial;
    }

    .ks-filter-desc {
        width: 50%;
        margin-bottom: 10px;
    }

    @media only screen and (max-width: 768px) {
      /* For mobile phones: */
      .ks-filter-desc {
        width: 100%;
      }
    }

    .counter-info {
        position: relative;
    }

    .disabled-link {
        pointer-events: none;
    }

    .csv-export-progress__circle-btn {
        width: 16px;
        height: 16px;
        border-radius: 50%;
        display: inline-flex;
        align-items: center;
        justify-content: center;
        vertical-align: middle;
    }

    .csv-export-progress__circle-btn-inner {
        width: 10px;
        height: 10px;
        border-radius: 50%;
        background: #DEE0E2;
    }

    .csv-export-button-active {
        background: #DEE0E2 !important;
        border-color: #DEE0E2 !important;
    }

    textarea {
        background: #FFFFFF;
        border: 1px solid #DEE0E2;
        border-radius: 2px;
        outline: none;
        cursor: auto;
        padding: 10px;
        width: 100%;
        resize: vertical;
    }

    textarea:active {
        /*border:0;*/
        outline:none;
        box-shadow:none;
    }

    textarea::-webkit-scrollbar {
        width: 15px;
        height: 15px;
        background-color: rgba(255,255,255,0);
    }

    textarea::-webkit-scrollbar-track {
        background-color: #ccc;
    }

    textarea::-webkit-scrollbar-thumb {
        background-color: #6EB116;
    }

    textarea::-webkit-scrollbar-track,
    textarea::-webkit-scrollbar-thumb {
        /*background: #6EB116;*/
        border-radius: 99px;
        border: 5px solid rgba(255,255,255,0);
        background-clip: padding-box;
    }
    textarea::-webkit-resizer {
        background-repeat: no-repeat;
        background-image: url("data:image/svg+xml,%3Csvg width='12' height='13' viewBox='0 0 12 13' fill='none' xmlns='http://www.w3.org/2000/svg'%3E%3Cpath fill-rule='evenodd' clip-rule='evenodd' d='M8.15741 11.8426C7.94753 11.6327 7.94753 11.2924 8.15741 11.0826L11.0826 8.15741C11.2924 7.94753 11.6327 7.94753 11.8426 8.15741C12.0525 8.36728 12.0525 8.70756 11.8426 8.91744L8.91744 11.8426C8.70756 12.0525 8.36728 12.0525 8.15741 11.8426Z' fill='%23DEE0E2'/%3E%3Cpath fill-rule='evenodd' clip-rule='evenodd' d='M4.15741 11.8436C3.94753 11.6337 3.94753 11.2934 4.15741 11.0836L11.0826 4.12665C11.1868 4.02243 11.3232 3.96996 11.4598 3.96925C11.5983 3.96854 11.737 4.021 11.8426 4.12665C11.9459 4.2299 11.9983 4.36469 12 4.5C12.0017 4.63975 11.9493 4.78005 11.8426 4.88668L4.91744 11.8436C4.70756 12.0535 4.36728 12.0535 4.15741 11.8436Z' fill='%23DEE0E2'/%3E%3Cpath fill-rule='evenodd' clip-rule='evenodd' d='M0.157408 11.8455C-0.0524692 11.6356 -0.0524692 11.2953 0.157408 11.0854L11.0826 0.1574C11.1868 0.0531726 11.3232 0.000705857 11.4598 0C11.5983 -0.000715483 11.737 0.0517513 11.8426 0.1574C11.9459 0.260643 11.9983 0.39544 12 0.530747C12.0017 0.6705 11.9493 0.810796 11.8426 0.917431L0.917438 11.8455C0.707561 12.0554 0.367284 12.0554 0.157408 11.8455Z' fill='%23DEE0E2'/%3E%3C/svg%3E");

    }

    .search_container {
        display: flex;
    }

    @media only screen and (max-width: 768px) {
        /* For mobile phones: */
        .search_container {
            display: flex;
            flex-direction: column;
        }
    }

    .search_example {
        padding: 10px;
        box-sizing: border-box;
        border-left: 1px solid #9CD651;
        color: #666666;
        margin-left: 70px;
    }

    @media only screen and (min-width: 1280px)
    {
        .search_example {
            margin-left: 10px;
        }
    }

    @media only screen and (max-width: 768px) {
        .search_example {
            margin-left: 0;
        }
    }

    ::v-slotted(.search_example > div:first-child) {
        margin-bottom: 10px;
    }

    ::v-slotted(.search_example h3) {
        display: block;
        font-size: 13px;
        line-height: 130%;
    }

    ::v-slotted(.search_example span) {
        display: block;
        font-size: 11px;
        line-height: 13px;
    }

    .report_name__searchkeywords textarea {
        margin-bottom: 10px;
    }
    ::v-slotted(.report_name__searchkeywords label) {
        margin-bottom: 5px;
        display: block;
    }

</style>
